// -Когда уйдет с экрана startingPoint, другой элемент (stickyElement) будет появляться

export default function findCoordinates() {
    const stickyElement = document.querySelector('[data-coordinat-sticky]');
    const startingPoint = document.querySelector('[data-coordinat]');


    if (!stickyElement && !startingPoint) return;

    function scrollHandler() {
        let bntCoordinatsTop = startingPoint.getBoundingClientRect().bottom;

        if (bntCoordinatsTop < 0)
            stickyElement.classList.add('opacity');
        else
            stickyElement.classList.remove('opacity');

        if(stickyElement.classList.contains('js-filter-open')) {
            const footer = document.querySelector('.nm-footer');

            if (window.innerHeight > footer.getBoundingClientRect().top)
                stickyElement.classList.remove('opacity');
        }
    }

    scrollHandler();

    window.addEventListener('scroll', scrollHandler);
}



// WEBPACK FOOTER //
// ./src/js/new-design/findCoordinates.js